module.exports = "https://web-assets.ifttt.com/packs/media/diy/ifttt-pro-banner-27ab267e.svg";